/**
 * Notification data models with Zod schemas
 * Explicit schema definitions with parsing validation
 */
import { parseISO } from "date-fns";
import { z } from "zod";

// Domain schema (camelCase)
export const NotificationSchema = z.object({
  id: z.string(),
  businessId: z.string(),
  type: z.string(),
  title: z.string(),
  message: z.string(),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  read: z.boolean(),
  readAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

// DTO schema (snake_case)
const NotificationDtoSchema = z.object({
  id: z.string(),
  business_id: z.string(),
  type: z.string(),
  title: z.string(),
  message: z.string(),
  entity_type: z.string().nullable(),
  entity_id: z.string().nullable(),
  read: z.boolean(),
  read_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

// Infer types
export type NotificationDto = z.infer<typeof NotificationDtoSchema>;
export type Notification = z.infer<typeof NotificationSchema>;

// ============================================================================
// CONVERSION UTILITIES
// ============================================================================

export function fromNotificationDtoToNotification(
  dto: NotificationDto
): Notification {
  const notificationDto = NotificationDtoSchema.parse(dto);

  return {
    id: notificationDto.id,
    businessId: notificationDto.business_id,
    type: notificationDto.type,
    title: notificationDto.title,
    message: notificationDto.message,
    entityType: notificationDto.entity_type,
    entityId: notificationDto.entity_id,
    read: notificationDto.read,
    readAt: notificationDto.read_at ? parseISO(notificationDto.read_at) : null,
    createdAt: parseISO(notificationDto.created_at),
    updatedAt: parseISO(notificationDto.updated_at),
  };
}
